/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import Footer from "./components/footer";
import Fields from "./components/field";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";

export default function TaxPersonal05() {
  const { formId, formField } = form;
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const [pickAll, setPickAll] = React.useState(false);
  const [list, setList] = React.useState([{ name: "04-1/ĐTV-TNCN", checked: false }]);

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  const handleChangeSwitch = (name, checked) => {
    if (pickAll) return;
    setList((prev) =>
      prev.map((item) => {
        if (item.name === name) {
          return { ...item, checked };
        }
        return item;
      })
    );
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} list={list} pickAll={pickAll} />
          <Actions
            list={list}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        </>
      )}
      <ModalCommon
        open={open}
        setOpen={setOpen}
        content={
          <ModalContent
            list={list}
            setList={setList}
            pickAll={pickAll}
            setPickAll={setPickAll}
            handleChangeSwitch={handleChangeSwitch}
          />
        }
      >
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế thu nhập cá nhân - Mẫu 04/NNG-TNCN
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với cá nhân không cư trú có thu nhập từ kinh doanh, cá nhân có thu nhập
                từ đầu tư vốn, bản quyền, nhượng quyền thương mại, trúng thưởng được trả từ nước
                ngoài)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <TaxPersonalTable setFieldValue={setFieldValue} />
                  <Footer
                    formData={{
                      values,
                      errors,
                      touched,
                      formField,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}
